import type { FaireProductEntity } from "../../entity_types/product";

export const p_e0o76l8h3x: FaireProductEntity = {
  token: "p_e0o76l8h3x",
  type: "product",
  name: "Baby Balm - Organic Healing Salve",
  brandToken: "b_1jklfuxs9g",
  brandName: "Euphoric Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/5be40240eefad1529a31ddf632bc0289030460f6013fc41e60a9114154a68381.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3b884378f4873ddab43067b68008a2412ec2991d219cfe6a647c83bc7e25b52.jpeg",
    "https://cdn.faire.com/fastly/8f0752b4dc2854730b284a92ad353fb3d2ba2b04f887a1e149afc16e78ac2da6.png",
    "https://cdn.faire.com/fastly/24b1823ef2fe408b8b3ca918ec3e095b0789cb61f06c1fe3fe70e3ceb867da79.jpeg",
    "https://cdn.faire.com/fastly/6b55d51aa50fdc8e0a4f875aa0b069ec850af50115877bca217f9dadb5ecad40.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Baby Balm Salve, a multitasking miracle worker made with 100% organic ingredients, designed to soothe your baby's most common skin ailments. This gentle balm offers relief from diaper rash, cradle cap, and pesky mosquito bites.\n\n🌿 A blend of Lavender and Chamomile flowers offers calming properties, while Comfrey and Chickweed leaf provide nourishment to tender skin.\n🌿 Aloe Vera's natural healing power, known for its incredible soothing and anti-inflammatory properties.\n🌿 Lavender essential oil imparts a delicate, relaxing aroma and supports skin restoration. Sweet Orange essential oil adds a fresh, uplifting scent and antimicrobial benefits, ensuring your baby's skin is protected.\n🌿 Coconut and Olive oils are nourishing and deeply moisturize, helping to restore the natural skin barrier.\n\nORGANIC INGREDIENTS: Lavender flowers, chamomile flowers, comfrey leaf, chickweed leaf, aloe vera, lavender essential oil, sweet orange essential oil infused in a beeswax coconut & olive oil base.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:40.510Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
